import styled, { css } from 'styled-components'
import { Link } from 'gatsby'

import { themeStyles, themeMedia } from '../../../styles/theme'
import icon_playbutton from '../../../images/icon_playbutton.svg'

export const StyledGameWrapper = styled(Link)`
  position: relative;
`

export const StyledLogin = styled.a`
  background-size: 40px;
  background: ${themeStyles.colors.accentColors.secondary.main}
    url('${icon_playbutton}') 7px no-repeat;
  color: ${themeStyles.colors.black.main};
  cursor: pointer;
  white-space: normal;
  display: inline-block;
  min-width: 60px;
  padding: 1.1rem 0 1.1rem 3.5rem;
  border-radius: 4px;
  text-align: left;
  line-height: 1;
  text-decoration: none;
`

export const StyledPlay = styled(Link)`
  background: ${themeStyles.colors.accentColors.secondary.main}
    url('${icon_playbutton}') center no-repeat;
  background-size: 40px;
  color: ${themeStyles.colors.black.main};
  cursor: pointer;
  display: inline-block;
  padding: 2rem;
  border-radius: 50%;
  text-decoration: none;
`

export const StyledPlayForFun = styled(Link)`
  text-align: center;
  margin-top: 0.5rem;
  color: ${themeStyles.colors.accentColors.secondary.main};
  text-decoration: none;
  font-weight: 300;
  font-size: 0.9em;
`

export const StyledAction = styled.div`
  display: none;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
  background: linear-gradient(
    183.07deg,
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.7) 42.85%,
    ${themeStyles.colors.black.main}
  );
  transition: opacity 0.3s ease;
  opacity: 0;
  ${(props) =>
    props.isLoggedIn &&
    css`
      pointer-events: none;
    `}

  ${themeMedia.desktop`
    display: flex;
  `};

  a {
    max-width: 80%;
    min-width: initial;
  }
`

export const StyledOuterWrapper = styled.div`
  position: relative;

  ${themeMedia.desktop`
    margin: 0;

    &:hover {
      ${StyledAction} {
        opacity: 1;
      }
    }
  `}
`

export const StyledInnerWrapper = styled.div`
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 49%);
  position: relative;
  padding: 0 0 ${(props) => (props.isWide ? 77 : 130)}% 0;

  border-radius: 4px;
  cursor: pointer;

  picture,
  img {
    position: absolute;
    top: 0px;
    left: 0px;
    border-radius: 4px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    ${(props) => props.isUnderMaintenance && 'filter: grayscale(100%);'}
  }
`

